/* eslint-disable */
import CustomLayout from './wrapPageElement';

export const wrapPageElement = CustomLayout;
